import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import masterData from "../components/masterData";
import { BASE_URL, CAL_URL } from "../../../configs/WebServiceUrl";
import { apiKeyHeader } from "../../../configs/ApiKeys";

// const BASE_URL = "http://localhost:5010";
// const BASE_URL = "https://web1024.docmaster.in:5010"
const api = axios

api.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      ...apiKeyHeader(), 
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const initialCalendarItemsState = {
  academicData: [],
  masterCompetitions: [],
  masterCelebrations: [],
  celebrations: [],
  masterawarenessDays: [],
  awarenessDays: [],
  masterHolidays: [],
  holidays: [],
  sessions: [],
  events: [],
  competitions: [],
  exams: [],
  ptms: [],
  status: "idle",
  error: null,
  calendarEvents: [],
  holidayCategories: [],
  competitionCategories: [],
  examCategories: [],
};
export const fetchHolidayCategoriesThunk = createAsyncThunk(
  "academicCalendar/fetchHolidayCategories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`${CAL_URL}/competition/categories`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchCompetitionCategoriesThunk = createAsyncThunk(
  "academicCalendar/fetchCompetitionCategories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`${CAL_URL}/competition/competitioncategories`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchExamCategoriesThunk = createAsyncThunk(
  "academicCalendar/fetchExamCategories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`${CAL_URL}/competition/exam-categories`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchProposedCompetitionsThunk = createAsyncThunk(
  "academicCalendar/fetchProposedCompetitions",
  async (_, { rejectWithValue }) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));
        const user_id = userData?.id; // Default to 1 if userData or id is not available
      const response = await api.get(
        `${BASE_URL}/competition/list-of-competitions/${user_id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchProposedHolidaysThunk = createAsyncThunk(
  "academicCalendar/fetchProposedHolidays",
  async ({ school_id }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `${CAL_URL}/competition/proposed-holidays/1`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const postHolidayThunk = createAsyncThunk(
  "academicCalendar/postHoliday",
  async (holidayData, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.post(
        `${BASE_URL}/holidays/create-holiday`,
        holidayData
      );
      dispatch(fetchHolidaysThunk());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchHolidaysThunk = createAsyncThunk(
  "academicCalendar/fetchHolidays",
  async ({ user_id, school_id = 1 }, { rejectWithValue }) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));
      const isUserRole=userData?.roles?.toLowerCase() === "user";
      const finalUserId = isUserRole ? userData?.parent_sub_id : user_id;
      const response = await api.get(
        `${BASE_URL}/holidays/view-holidays/${finalUserId}`,
        {
          params: {
            school_id,
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteHolidayThunk = createAsyncThunk(
  "academicCalendar/deleteHoliday",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      await api.delete(`${BASE_URL}/holidays/delete-holiday/${id}`);
      dispatch(fetchHolidaysThunk());
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const updateHolidayThunk = createAsyncThunk(
  "academicCalendar/updateHoliday",
  async ({ id, holidayData }, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.put(`${BASE_URL}/holidays/${id}`, holidayData);
      dispatch(fetchHolidaysThunk());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createSessionThunk = createAsyncThunk(
  "academicCalendar/createSession",
  async (sessionData, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.post(`${BASE_URL}/sessions`, sessionData);
      dispatch(fetchSessionsThunk());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchSessionsThunk = createAsyncThunk(
  "academicCalendar/fetchSessions",
  async (_, { rejectWithValue }) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));
      const user_id = userData?.id; // Default to 1 if userData or id is not available
      const isUserRole = userData?.roles?.toLowerCase() === "user";
      const finalUserId = isUserRole ? userData?.parent_sub_id : user_id;
      const response = await api.get(`${BASE_URL}/sessions/${finalUserId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateSessionThunk = createAsyncThunk(
  "academicCalendar/updateSession",
  async ({ id, sessionData }, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.put(`${BASE_URL}/sessions/${id}`, sessionData);
      dispatch(fetchSessionsThunk());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteSessionThunk = createAsyncThunk(
  "academicCalendar/deleteSession",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      await api.delete(`${BASE_URL}/sessions/${id}`);
      dispatch(fetchSessionsThunk());
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchProposedCelebrationsThunk = createAsyncThunk(
  "academicCalendar/fetchProposedCelebrations",
  async ({ user_id }, { rejectWithValue }) => {
    try {
      // const user_id = 5;
      const response = await axios.get(
        `${CAL_URL}/competition/list-of-celebrations/${user_id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchCelebrationsThunk = createAsyncThunk(
  "academicCalendar/fetchCelebrations",
  async ({ user_id }, { rejectWithValue }) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));
        const isUserRole = userData?.roles?.toLowerCase() === "user";
      const finalUserId = isUserRole ? userData?.parent_sub_id : user_id;
      const response = await api.get(
        `${BASE_URL}/competition/celebrations/${finalUserId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const createCelebrationThunk = createAsyncThunk(
  "academicCalendar/createCelebration",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.post(
        `${BASE_URL}/competition/celebrations`,
        payload
      );
      dispatch(fetchCelebrationsThunk());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const deleteCelebrationThunk = createAsyncThunk(
  "academicCalendar/deleteCelebration",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      await api.delete(`${BASE_URL}/competition/celebration/${id}`);
      dispatch(fetchCelebrationsThunk());
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const updateCelebrationThunk = createAsyncThunk(
  "academicCalendar/updateCelebration",
  async ({ id, celebrationData }, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.put(
        `${BASE_URL}/competition/celebration/${id}`,
        celebrationData
      );
      dispatch(fetchCelebrationsThunk());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchProposedAwarenessThunk = createAsyncThunk(
  "academicCalendar/fetchProposedAwareness",
  async ({ user_id }, { rejectWithValue }) => {
    try {
      // const user_id = 5;
      const response = await api.get(
        `${CAL_URL}/competition/list-of-awareness_days/${user_id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchAwarenessThunk = createAsyncThunk(
  "academicCalendar/fetchAwareness",
  async ({ user_id }, { rejectWithValue }) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));
        const isUserRole = userData?.roles?.toLowerCase() === "user";
      const finalUserId = isUserRole ? userData?.parent_sub_id : user_id;
      const response = await api.get(
        `${BASE_URL}/competition/awareness-days/${finalUserId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const createAwarenessThunk = createAsyncThunk(
  "academicCalendar/createAwareness",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.post(
        `${BASE_URL}/competition/awareness-days`,
        payload
      );
      dispatch(fetchAwarenessThunk());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const deleteAwarenessThunk = createAsyncThunk(
  "academicCalendar/deleteAwareness",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      await api.delete(`${BASE_URL}/competition/awareness-day/${id}`);
      dispatch(fetchAwarenessThunk());
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const updateAwarenessThunk = createAsyncThunk(
  "academicCalendar/updateCelebration",
  async ({ id, awarenessData }, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.put(
        `${BASE_URL}/competition/awareness-day/${id}`,
        awarenessData
      );
      dispatch(fetchAwarenessThunk());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createEventThunk = createAsyncThunk(
  "academicCalendar/createEvent",
  async (eventData, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.post(`${BASE_URL}/events`, eventData);
      dispatch(fetchEventsThunk());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchEventsThunk = createAsyncThunk(
  "academicCalendar/fetchEvents",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(`${BASE_URL}/events`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateEventThunk = createAsyncThunk(
  "academicCalendar/updateEvent",
  async ({ id, eventData }, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.put(`${BASE_URL}/events/${id}`, eventData);
      dispatch(fetchEventsThunk());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteEventThunk = createAsyncThunk(
  "academicCalendar/deleteEvent",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      await api.delete(`${BASE_URL}/events/${id}`);
      dispatch(fetchEventsThunk());
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const createCompetitionThunk = createAsyncThunk(
  "academicCalendar/createCompetition",
  async (competitionData, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.post(
        `${BASE_URL}/competition/create-competition`,
        competitionData
      );
      dispatch(fetchCompetitionsThunk());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const fetchCompetitionsThunk = createAsyncThunk(
  "academicCalendar/fetchCompetitions",
  async ({ user_id }, { rejectWithValue }) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));
        const isUserRole = userData?.roles?.toLowerCase() === "user";
      const finalUserId = isUserRole ? userData?.parent_sub_id : user_id;
      const response = await api.get(
        `${BASE_URL}/competition/all-competitions/${finalUserId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateCompetitionThunk = createAsyncThunk(
  "academicCalendar/updateCompetition",
  async ({ id, competitionData }, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.put(
        `${BASE_URL}/competition/${id}`,
        competitionData
      );
      dispatch(fetchCompetitionsThunk());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteCompetitionThunk = createAsyncThunk(
  "academicCalendar/deleteCompetition",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      await api.delete(`${BASE_URL}/competition/competition/${id}`);
      dispatch(fetchCompetitionsThunk());
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createExamThunk = createAsyncThunk(
  "academicCalendar/createExam",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.post(`${BASE_URL}/exam/examinations`, payload);
      dispatch(fetchExamsThunk()); // Optional: refresh the exam list
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchExamsThunk = createAsyncThunk(
  "academicCalendar/fetchExams",
  async ({ user_id }, { rejectWithValue }) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));
        const isUserRole = userData?.roles?.toLowerCase() === "user";
      const finalUserId = isUserRole ? userData?.parent_sub_id : user_id;
      const response = await api.get(
        `${BASE_URL}/exam/examinations/${finalUserId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateExamThunk = createAsyncThunk(
  "academicCalendar/updateExam",
  async ({ id, examData }, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.put(
        `${BASE_URL}/exam/examination/${id}`,
        examData
      );
      dispatch(fetchExamsThunk());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteExamThunk = createAsyncThunk(
  "academicCalendar/deleteExam",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      await api.delete(`${BASE_URL}/exam/${id}`);
      dispatch(fetchExamsThunk());
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createPtmThunk = createAsyncThunk(
  "academicCalendar/createPtm",
  async (ptmData, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.post(`${BASE_URL}/ptms`, ptmData);
      dispatch(fetchPtmsThunk());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchPtmsThunk = createAsyncThunk(
  "academicCalendar/fetchPtms",
  async (_, { rejectWithValue }) => {
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));
      const isUserRole = userData?.roles?.toLowerCase() === "user";
      const finalUserId = isUserRole ? userData?.parent_sub_id : userData?.id;
      const response = await api.get(`${BASE_URL}/ptms/${finalUserId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updatePtmThunk = createAsyncThunk(
  "academicCalendar/updatePtm",
  async ({ id, ptmData }, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.put(`${BASE_URL}/ptms/${id}`, ptmData);
      dispatch(fetchPtmsThunk());
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deletePtmThunk = createAsyncThunk(
  "academicCalendar/deletePtm",
  async (id, { rejectWithValue, dispatch }) => {
    try {
      await api.delete(`${BASE_URL}/ptms/${id}`);
      dispatch(fetchPtmsThunk());
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const academicCalendarSlice = createSlice({
  name: "academicCalendar",
  initialState: initialCalendarItemsState,
  reducers: {
    addAwarenessDay: (s, { payload }) => {
      s.awarenessDays.push(payload);
    },
    deleteAwarenessDay: (s, { payload }) => {
      s.awarenessDays = s.awarenessDays.filter((a) => a.id !== payload);
    },
    addCalendarItem: (state, action) => {
      state.academicData.push(action.payload);
      state.calendarEvents.push(action.payload);
      localStorage.setItem(
        "academicCalendarData",
        JSON.stringify(state.academicData)
      );
    },
    updateCalendarItem: (state, action) => {
      const index = state.academicData.findIndex(
        (item) => item.id === action.payload.id
      );
      if (index !== -1) {
        state.academicData[index] = action.payload;
        state.calendarEvents = state.calendarEvents.map((item) =>
          item.id === action.payload.id ? action.payload : item
        );
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      }
    },
    deleteCalendarItem: (state, action) => {
      state.academicData = state.academicData.filter(
        (item) => item.id !== action.payload
      );
      state.calendarEvents = state.calendarEvents.filter(
        (item) => item.id !== action.payload
      );
      localStorage.setItem(
        "academicCalendarData",
        JSON.stringify(state.academicData)
      );
    },
    loadCalendarItemsFromLocalStorage: (state) => {
      const storedData = localStorage.getItem("academicCalendarData");
      if (storedData) {
        state.academicData = JSON.parse(storedData);
        state.calendarEvents = JSON.parse(storedData);
      }
    },
    addHolidayToState: (state, action) => {
      const newItem = action.payload;
      if (!state.holidays.some((holiday) => holiday.id === newItem.id)) {
        state.holidays.push(newItem);
        state.academicData.push({
          id: newItem.id,
          date: moment(newItem.start_date).format("DD-MM-YYYY"),
          end_date: moment(newItem.end_date).format("DD-MM-YYYY"),
          type: "holiday",
          name: newItem.details,
          description: newItem.details,
        });
        state.calendarEvents.push({
          id: newItem.id,
          date: moment(newItem.start_date).format("DD-MM-YYYY"),
          end_date: moment(newItem.end_date).format("DD-MM-YYYY"),
          type: "holiday",
          name: newItem.details,
          description: newItem.details,
        });
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      }
    },
    addCompetitionToState: (state, action) => {
      const newItem = action.payload;
      if (!state.competitions.some((comp) => comp.id === newItem.id)) {
        state.competitions.push(newItem);
        state.academicData.push({
          id: newItem.id,
          date: moment(newItem.start_date).format("DD-MM-YYYY"),
          end_date: moment(newItem.end_date).format("DD-MM-YYYY"),
          type: "competition",
          name: newItem.details,
          description: newItem.details,
          start_time: newItem.start_time,
          end_time: newItem.end_time,
        });
        state.calendarEvents.push({
          id: newItem.id,
          date: moment(newItem.start_date).format("DD-MM-YYYY"),
          end_date: moment(newItem.end_date).format("DD-MM-YYYY"),
          type: "competition",
          name: newItem.details,
          description: newItem.details,
          start_time: newItem.start_time,
          end_time: newItem.end_time,
        });
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      }
    },
    addExamToState: (state, action) => {
      const newItem = action.payload;
      if (!state.exams.some((exam) => exam.id === newItem.id)) {
        state.exams.push(newItem);
        state.academicData.push({
          id: newItem.id,
          date: moment(newItem.start_date).format("DD-MM-YYYY"),
          end_date: moment(newItem.end_date).format("DD-MM-YYYY"),
          type: "exam",
          name: newItem.details,
          description: newItem.details,
          start_time: newItem.start_time,
          end_time: newItem.end_time,
        });
        state.calendarEvents.push({
          id: newItem.id,
          date: moment(newItem.start_date).format("DD-MM-YYYY"),
          end_date: moment(newItem.end_date).format("DD-MM-YYYY"),
          type: "exam",
          name: newItem.details,
          description: newItem.details,
          start_time: newItem.start_time,
          end_time: newItem.end_time,
        });
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHolidayCategoriesThunk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchHolidayCategoriesThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.holidayCategories = action.payload;
      })
      .addCase(fetchHolidayCategoriesThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchCompetitionCategoriesThunk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCompetitionCategoriesThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.competitionCategories = action.payload;
      })
      .addCase(fetchCompetitionCategoriesThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchExamCategoriesThunk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchExamCategoriesThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.examCategories = action.payload;
      })
      .addCase(fetchExamCategoriesThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(createExamThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        const newExamItem = {
          id: action.payload.id,
          date: moment(action.payload.start_date).format("DD-MM-YYYY"),
          end_date: moment(action.payload.end_date).format("DD-MM-YYYY"),
          type: "exam",
          name: action.payload.details,
          description: action.payload.details,
          start_time: action.payload.start_time,
          end_time: action.payload.end_time,
        };
        state.exams.push(action.payload);
        state.academicData.push(newExamItem);
        state.calendarEvents.push(newExamItem);
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      })
      .addCase(createExamThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchExamsThunk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchExamsThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.exams = action.payload;
        const fetchedExamsAsCalendarItems = action.payload.map((item) => ({
          id: item.id,
          date: moment(item.start_date).format("DD-MM-YYYY"),
          end_date: moment(item.end_date).format("DD-MM-YYYY"),
          type: "exam",
          name: item.details,
          description: item.details,
          start_time: item.start_time,
          end_time: item.end_time,
        }));
        state.academicData = [
          ...state.academicData.filter((item) => item.type !== "exam"),
          ...fetchedExamsAsCalendarItems,
        ];
        state.calendarEvents = [
          ...state.calendarEvents.filter((item) => item.type !== "exam"),
          ...fetchedExamsAsCalendarItems,
        ];
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      })
      .addCase(fetchExamsThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(updateExamThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        // Find and update the exam in state.exams
        const examIndex = state.exams.findIndex(
          (exam) => exam.id === action.payload.id
        );
        if (examIndex !== -1) {
          state.exams[examIndex] = action.payload;
        }

        // Find and update the exam in academicData and calendarEvents
        const updatedExamItem = {
          id: action.payload.id,
          date: moment(action.payload.start_date).format("DD-MM-YYYY"),
          end_date: moment(action.payload.end_date).format("DD-MM-YYYY"),
          type: "exam",
          name: action.payload.details,
          description: action.payload.details,
          start_time: action.payload.start_time,
          end_time: action.payload.end_time,
        };
        state.academicData = state.academicData.map((item) =>
          item.type === "exam" && item.id === updatedExamItem.id
            ? updatedExamItem
            : item
        );
        state.calendarEvents = state.calendarEvents.map((item) =>
          item.type === "exam" && item.id === updatedExamItem.id
            ? updatedExamItem
            : item
        );
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      })
      .addCase(updateExamThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(deleteExamThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.exams = state.exams.filter((exam) => exam.id !== action.payload);
        // You might also need to update other parts of your state that hold exam data, e.g., academicData, calendarEvents
        state.academicData = state.academicData.filter(
          (item) => !(item.type === "exam" && item.id === action.payload)
        );
        state.calendarEvents = state.calendarEvents.filter(
          (item) => !(item.type === "exam" && item.id === action.payload)
        );
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      })
      .addCase(deleteExamThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchProposedAwarenessThunk.fulfilled, (state, action) => {
        state.masterawarenessDays = action.payload;
      })

      .addCase(fetchAwarenessThunk.fulfilled, (state, action) => {
        state.awarenessDays = action.payload;
        const mappedAwarenessDays = action.payload.map((item) => ({
          id: item.id,
          awareness_id: item.awareness_id,
          date: moment(item.start_date).format("DD-MM-YYYY"),
          // start_date: item.start_date, // <--- ADD THIS LINE: Preserve original start_date
          end_date: moment(item.end_date).format("DD-MM-YYYY"),
          type: "awarenessDay",
          name: item.details,
          description: item.details,
          start_time: item.start_time,
          end_time: item.end_time,
        }));
        state.academicData = [
          ...state.academicData.filter((item) => item.type !== "awarenessDay"),
          ...mappedAwarenessDays,
        ];
        state.calendarEvents = [
          ...state.calendarEvents.filter(
            (item) => item.type !== "awarenessDay"
          ),
          ...mappedAwarenessDays,
        ];
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      })

      .addCase(createAwarenessThunk.fulfilled, (state, action) => {
        state.awarenessDays.push(action.payload);
        const newAwarenessDayItem = {
          id: action.payload.id,
          date: moment(action.payload.start_date).format("DD-MM-YYYY"),
          end_date: moment(action.payload.end_date).format("DD-MM-YYYY"),
          type: "awarenessDay",
          name: action.payload.details,
          description: action.payload.details,
          start_time: action.payload.start_time,
          end_time: action.payload.end_time,
        };
        state.academicData.push(newAwarenessDayItem);
        state.calendarEvents.push(newAwarenessDayItem);
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      })
      .addCase(deleteAwarenessThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.awarenessDays = state.awarenessDays.filter(
          (awarenessDay) => awarenessDay.id !== action.payload
        );
        state.academicData = state.academicData.filter(
          (item) =>
            !(item.type === "awarenessDay" && item.id === action.payload)
        );
        state.calendarEvents = state.calendarEvents.filter(
          (item) =>
            !(item.type === "awarenessDay" && item.id === action.payload)
        );
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      })
      .addCase(deleteAwarenessThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(fetchCelebrationsThunk.fulfilled, (state, action) => {
        console.log("🎯 Celebrations Payload from Backend:", action.payload);
        state.celebrations = action.payload;
        const mappedCelebrations = action.payload.map((item) => ({
          id: item.id,
          celebration_id: item.celebration_id,
          date: moment(item.start_date).format("DD-MM-YYYY"),
          end_date: moment(item.end_date).format("DD-MM-YYYY"),
          type: "celebration",
          name: item.details,
          description: item.details,
          start_time: item.start_time,
          end_time: item.end_time,
        }));

        state.academicData = [
          ...state.academicData.filter((item) => item.type !== "celebration"),
          ...mappedCelebrations,
        ];
        state.calendarEvents = [
          ...state.calendarEvents.filter((item) => item.type !== "celebration"),
          ...mappedCelebrations,
        ];
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      })

      .addCase(fetchProposedCelebrationsThunk.fulfilled, (state, action) => {
        state.masterCelebrations = action.payload;
      })

      .addCase(createCelebrationThunk.fulfilled, (state, action) => {
        state.celebrations.push(action.payload);
        const newCelebrationItem = {
          id: action.payload.id,
          date: moment(action.payload.start_date).format("DD-MM-YYYY"),
          end_date: moment(action.payload.end_date).format("DD-MM-YYYY"),
          type: "celebration",
          name: action.payload.details,
          description: action.payload.details,
          start_time: action.payload.start_time,
          end_time: action.payload.end_time,
        };
        state.academicData.push(newCelebrationItem);
        state.calendarEvents.push(newCelebrationItem);
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      })
      .addCase(deleteCelebrationThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.celebrations = state.celebrations.filter(
          (celebration) => celebration.id !== action.payload
        );
        state.academicData = state.academicData.filter(
          (item) => !(item.type === "celebration" && item.id === action.payload)
        );
        state.calendarEvents = state.calendarEvents.filter(
          (item) => !(item.type === "celebration" && item.id === action.payload)
        );
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      })
      .addCase(deleteCelebrationThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(updateCelebrationThunk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateCelebrationThunk.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(updateCelebrationThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(fetchProposedCompetitionsThunk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchProposedCompetitionsThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.masterCompetitions = action.payload;
      })
      .addCase(fetchProposedCompetitionsThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchProposedHolidaysThunk.fulfilled, (state, action) => {
        state.masterHolidays = action.payload;
      })
      .addCase(fetchProposedHolidaysThunk.rejected, (state, action) => {
        state.masterHolidays = {};
        state.error = action.payload;
      })
      .addCase(postHolidayThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(postHolidayThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchHolidaysThunk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchHolidaysThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.holidays = action.payload;
        const fetchedHolidaysAsCalendarItems = action.payload.map((item) => ({
          id: item.id,
          date: moment(item.start_date).format("DD-MM-YYYY"),
          end_date: moment(item.end_date).format("DD-MM-YYYY"),
          type: "holiday",
          name: item.details,
          description: item.details,
        }));
        state.academicData = [
          ...state.academicData.filter((item) => item.type !== "holiday"),
          ...fetchedHolidaysAsCalendarItems,
        ];
        state.calendarEvents = [
          ...state.calendarEvents.filter((item) => item.type !== "holiday"),
          ...fetchedHolidaysAsCalendarItems,
        ];
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      })
      .addCase(fetchHolidaysThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(deleteHolidayThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.holidays = state.holidays.filter(
          (holiday) => holiday.id !== action.payload
        );
        state.academicData = state.academicData.filter(
          (item) => !(item.type === "holiday" && item.id === action.payload)
        );
        state.calendarEvents = state.calendarEvents.filter(
          (item) => !(item.type === "holiday" && item.id === action.payload)
        );
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      })
      .addCase(deleteHolidayThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(updateHolidayThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(updateHolidayThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(createSessionThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(createSessionThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchSessionsThunk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchSessionsThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.sessions = action.payload;
        const fetchedSessionsAsCalendarItems = action.payload.flatMap(
          (item) => [
            {
              id: item.id + "-start",
              originalId: item.id,
              date: moment(item.start_date).format("DD-MM-YYYY"),
              type: "sessionStart",
              name: "Session Start",
              description: `Academic session begins on ${moment(
                item.start_date
              ).format("DD MMMMYYYY")}`,
            },
            {
              id: item.id + "-end",
              originalId: item.id,
              date: moment(item.end_date).format("DD-MM-YYYY"),
              type: "sessionEnd",
              name: "Session End",
              description: `Academic session ends on ${moment(
                item.end_date
              ).format("DD MMMMYYYY")}`,
            },
          ]
        );
        state.academicData = [
          ...state.academicData.filter(
            (item) => item.type !== "sessionStart" && item.type !== "sessionEnd"
          ),
          ...fetchedSessionsAsCalendarItems,
        ];
        state.calendarEvents = [
          ...state.calendarEvents.filter(
            (item) => item.type !== "sessionStart" && item.type !== "sessionEnd"
          ),
          ...fetchedSessionsAsCalendarItems,
        ];
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      })
      .addCase(fetchSessionsThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(updateSessionThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(updateSessionThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(deleteSessionThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.sessions = state.sessions.filter(
          (session) => session.id !== action.payload
        );
        state.academicData = state.academicData.filter(
          (item) =>
            !(item.type === "sessionStart" || item.type === "sessionEnd") ||
            item.originalId !== action.payload
        );
        state.calendarEvents = state.calendarEvents.filter(
          (item) =>
            !(item.type === "sessionStart" || item.type === "sessionEnd") ||
            item.originalId !== action.payload
        );
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      })
      .addCase(deleteSessionThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(createEventThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(createEventThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchEventsThunk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchEventsThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.events = action.payload;
        const fetchedEventsAsCalendarItems = action.payload.map((item) => ({
          id: item.id,
          date: moment(item.start_date).format("DD-MM-YYYY"),
          end_date: moment(item.end_date).format("DD-MM-YYYY"),
          type: "event",
          name: item.details,
          description: item.details,
          start_time: item.start_time,
          end_time: item.end_time,
        }));
        state.academicData = [
          ...state.academicData.filter((item) => item.type !== "event"),
          ...fetchedEventsAsCalendarItems,
        ];
        state.calendarEvents = [
          ...state.calendarEvents.filter((item) => item.type !== "event"),
          ...fetchedEventsAsCalendarItems,
        ];
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      })
      .addCase(fetchEventsThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(updateEventThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(updateEventThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(deleteEventThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.events = state.events.filter(
          (event) => event.id !== action.payload
        );
        state.academicData = state.academicData.filter(
          (item) => !(item.type === "event" && item.id === action.payload)
        );
        state.calendarEvents = state.calendarEvents.filter(
          (item) => !(item.type === "event" && item.id === action.payload)
        );
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      })
      .addCase(deleteEventThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(createCompetitionThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(createCompetitionThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchCompetitionsThunk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCompetitionsThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.competitions = action.payload;
        const fetchedCompetitionsAsCalendarItems = action.payload.map(
          (item) => ({
            id: item.id,
            date: moment(item.start_date).format("DD-MM-YYYY"),
            end_date: moment(item.end_date).format("DD-MM-YYYY"),
            type: "competition",
            name: item.details,
            description: item.details,
            start_time: item.start_time,
            end_time: item.end_time,
          })
        );
        state.academicData = [
          ...state.academicData.filter((item) => item.type !== "competition"),
          ...fetchedCompetitionsAsCalendarItems,
        ];
        state.calendarEvents = [
          ...state.calendarEvents.filter((item) => item.type !== "competition"),
          ...fetchedCompetitionsAsCalendarItems,
        ];
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      })
      .addCase(fetchCompetitionsThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(updateCompetitionThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(updateCompetitionThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(deleteCompetitionThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.competitions = state.competitions.filter(
          (competition) => competition.id !== action.payload
        );
        // You might also need to update other parts of your state that hold competition data, e.g., academicData, calendarEvents
        state.academicData = state.academicData.filter(
          (item) => !(item.type === "competition" && item.id === action.payload)
        );
        state.calendarEvents = state.calendarEvents.filter(
          (item) => !(item.type === "competition" && item.id === action.payload)
        );
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      })
      .addCase(deleteCompetitionThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(createPtmThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(createPtmThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchPtmsThunk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPtmsThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.ptms = action.payload;
        const fetchedPtmsAsCalendarItems = action.payload.map((item) => ({
          id: item.id,
          date: moment(item.start_date).format("DD-MM-YYYY"),
          end_date: moment(item.end_date).format("DD-MM-YYYY"),
          type: "ptm",
          name: item.details,
          description: item.details,
          start_time: item.start_time,
          end_time: item.end_time,
        }));
        state.academicData = [
          ...state.academicData.filter((item) => item.type !== "ptm"),
          ...fetchedPtmsAsCalendarItems,
        ];
        state.calendarEvents = [
          ...state.calendarEvents.filter((item) => item.type !== "ptm"),
          ...fetchedPtmsAsCalendarItems,
        ];
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      })
      .addCase(fetchPtmsThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(updatePtmThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(updatePtmThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(deletePtmThunk.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.ptms = state.ptms.filter((ptm) => ptm.id !== action.payload);
        state.academicData = state.academicData.filter(
          (item) => !(item.type === "ptm" && item.id === action.payload)
        );
        state.calendarEvents = state.calendarEvents.filter(
          (item) => !(item.type === "ptm" && item.id === action.payload)
        );
        localStorage.setItem(
          "academicCalendarData",
          JSON.stringify(state.academicData)
        );
      })
      .addCase(deletePtmThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});
// addAwarenessDay,
//   deleteAwarenessDay,
export const {
  addCalendarItem,
  updateCalendarItem,
  deleteCalendarItem,
  loadCalendarItemsFromLocalStorage,
  addHolidayToState,
  addCompetitionToState,
  addExamToState,
} = academicCalendarSlice.actions;

export default academicCalendarSlice.reducer;
